import React from 'react';
import { Link } from 'react-router-dom';
import { Card, CardBody, CardHeader, Col, Row } from 'reactstrap';

const CardWithError = ({ title }) => {
    return (
        <React.Fragment>
            <Card className='card-height-100'>
                {title ? (
                    <CardHeader className='p-2'>
                        <h5 className="card-title mb-0">{title}</h5>
                    </CardHeader>
                ) : null}
                <CardBody>
                    <div className="d-flex justify-content-center align-items-center p-3">
                        <div className="text-center">
                            <div className="avatar-md">
                                <span className="avatar-title bg-danger-subtle rounded-circle fs-1">
                                    <i className="ri-alarm-warning-fill text-danger"></i>
                                </span>
                            </div>
                        </div>
                    </div>
                    <p className="fs-16 lh-base text-center">Ha ocurrido un imprevisto.</p>
                    <p className="text-center">Por favor, contacte al administrador del sistema o a mesa de ayuda.</p>
                </CardBody>
            </Card>
        </React.Fragment>
    );
};

export default CardWithError;
